<template>
  <v-form ref="form" class="py-6">
    <v-row>
      <!-- Tên đồng phục -->

      <v-row style="padding: 12px">
        <v-col cols="12" class="pb-0">
          <v-text-field v-model="name" label="Tên đồng phục *" :rules="[$rules.required]" outlined dense />
        </v-col>
        <!-- Trạng thái hoạt động -->
        <!-- <v-col cols="1" class="pb-0 align-center justify-center" style="justify-items: center">
          <v-checkbox
            v-model="isActiveStatus"
            color="primary"
            hide-details
            dense
            @change="handleStatusChange"
            style="margin-top: 5px"
          />
        </v-col> -->
      </v-row>
      <v-col cols="12" class="form-height">
        <v-row>
          <v-col cols="12" class="py-0">
            <v-divider class="" />
          </v-col>
          <v-col cols="12" class="pb-0">
            <div class="d-flex align-center mb-2">
              <span class="font-weight-bold mr-2">Áp dụng <span class="red--text">*</span></span>
            </div>
            <v-select
              v-model="academicLevel"
              :items="academicLevelOptions"
              item-text="title"
              item-value="_id"
              label="Chọn cấp học"
              :rules="[$rules.required]"
              outlined
              dense
            />
          </v-col>
          <v-col cols="12" class="py-0">
            <v-divider class="" />
          </v-col>

          <!-- Upload ảnh đồng phục -->

          <v-col cols="12">
            <div class="mb-2 font-weight-bold">Ảnh minh hoạ</div>

            <div class="d-flex flex-wrap align-start">
              <div v-for="(img, index) in uniformImages" :key="index" class="image-preview-wrapper mr-2 mb-2">
                <div class="image-preview" :style="{ backgroundImage: `url(${previewImage(img)})` }">
                  <v-btn icon small class="remove-image-btn" @click="removeUniformImage(index)">
                    <v-icon color="red" small>mdi-close</v-icon>
                  </v-btn>
                </div>
              </div>

              <div class="image-upload-add mr-2 mb-2" @click="triggerImageUpload">
                <v-icon size="32">mdi-plus</v-icon>
              </div>
            </div>

            <input
              ref="uniformFileInput"
              class="d-none"
              type="file"
              accept="image/*"
              multiple
              @change="handleUniformImageChange"
            />
          </v-col>

          <v-col cols="12" class="py-0">
            <v-divider class="" />
          </v-col>

          <!-- Phân loại đồng phục -->

          <v-col cols="12" class="pb-0 mb-4">
            <div class="d-flex align-center mb-2">
              <span class="font-weight-bold mr-2">Phân loại chi tiết</span>
            </div>

            <div v-for="(option, oIndex) in options" :key="oIndex" class="">
              <v-row>
                <v-col cols="1" class="d-flex item-category justify-center">
                  <v-btn icon small @click="removeOption(oIndex)" v-if="oIndex === 1">
                    <v-icon color="red">mdi-close</v-icon>
                  </v-btn>
                </v-col>

                <v-col cols="5">
                  <v-text-field dense outlined v-model="option.type" label="Tên phân loại" :rules="[$rules.required]" />
                </v-col>

                <v-col cols="5">
                  <v-text-field dense outlined v-model="option.values[0]" label="Nội dung" :rules="[$rules.required]" />
                </v-col>

                <v-col cols="1" class="d-flex item-category justify-center" v-if="option.values.length !== 1">
                  <v-btn icon small @click="removeItem(oIndex)">
                    <v-icon color="red">mdi-delete</v-icon>
                  </v-btn>
                </v-col>

                <v-col cols="1" class="d-flex item-category justify-center" v-if="option.values.length === 1">
                  <v-btn icon small @click="addItem(oIndex)">
                    <v-icon color="primary">mdi-plus</v-icon>
                  </v-btn>
                </v-col>
              </v-row>

              <div v-for="(item, iIndex) in option.values.slice(1)" :key="iIndex">
                <v-row>
                  <v-col cols="5" offset="6">
                    <v-text-field
                      dense
                      outlined
                      v-model="option.values[iIndex + 1]"
                      label="Nội dung"
                      :rules="[$rules.required]"
                    />
                  </v-col>

                  <v-col
                    cols="1"
                    class="d-flex item-category justify-center"
                    v-if="iIndex !== option.values.length - 2"
                  >
                    <v-btn
                      v-if="iIndex !== option.values.length - 2"
                      icon
                      small
                      @click="removeItem(oIndex, iIndex + 1)"
                    >
                      <v-icon color="red">mdi-delete</v-icon>
                    </v-btn>
                  </v-col>

                  <v-col
                    cols="1"
                    class="d-flex item-category justify-center"
                    v-if="iIndex === option.values.length - 2"
                  >
                    <v-btn icon small @click="addItem(oIndex)">
                      <v-icon color="primary">mdi-plus</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </div>

              <v-row>
                <v-col cols="12" class="" v-if="options.length == 1" style="text-align: right; padding-top: 0px">
                  <v-btn
                    outlined
                    color="primary"
                    text
                    @click="addOption"
                    :disabled="options.length >= 2"
                    style="border: 1px solid"
                  >
                    <v-icon left>mdi-plus</v-icon> Thêm phân loại
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </v-col>

          <v-col cols="12" class="py-0">
            <v-divider class="" />
          </v-col>

          <!-- Combinations Table -->

          <v-col cols="12">
            <div class="font-weight-bold">Bảng giá theo phân loại</div>

            <v-simple-table dense>
              <thead>
                <tr>
                  <th v-if="hasOption(0)">{{ options[0].type || 'Phân loại 1' }}</th>

                  <th v-if="hasOption(1)">{{ options[1].type || 'Phân loại 2' }}</th>

                  <th>Giá</th>

                  <th>Có hoạt động</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(comb, index) in combinations" :key="index">
                  <td v-if="hasOption(0)">{{ comb.optionOne && comb.optionOne.name }}</td>

                  <td v-if="hasOption(1)">{{ comb.optionTwo && comb.optionTwo.name }}</td>

                  <td class="price-input-wrapper">
                    <v-text-field
                      class="mt-4 right-input"
                      :value="formatCurrency(comb.price)"
                      @input="combinations[index].price = $event.replace(/[^\d]/g, '')"
                      dense
                      outlined
                      placeholder="Giá"
                    />

                    <div class="price-unit">
                      <div class="divider"></div>

                      <span>VNĐ</span>
                    </div>
                  </td>

                  <td class="text-center justify-items-center" style="justify-items: center; width: 120px">
                    <v-checkbox class="mt-0 pt-0" v-model="combinations[index].isActive" hide-details dense />
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>

          <v-col cols="12" class="py-0">
            <v-divider class="" />
          </v-col>
          <v-col cols="12">
            <div class="font-weight-bold mb-2">Ghi chú</div>
            <v-textarea
              v-model="note"
              outlined
              dense
              placeholder="Nhập ghi chú cho đồng phục..."
              auto-grow
              rows="2"
              no-resize
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  props: {
    uniformData: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      name: '',
      note: '',
      academicLevel: '',
      academicLevelOptions: [],
      // isActiveStatus: true,
      activeStatus: 'working', // Giá trị mặc định
      options: [
        {
          type: '',
          values: [''],
        },
      ],
      combinations: [],
      uniformImages: [],
      rawImageRemoved: false,
      $rules: {
        required: v => !!v || 'Không được để trống',
      },
    }
  },
  mounted() {
    // this.addOption()
    this.fetchAcademicLevels()

    if (this.uniformData && this.uniformData.academicLevel) {
      this.academicLevel =
        typeof this.uniformData.academicLevel === 'object'
          ? this.uniformData.academicLevel._id
          : this.uniformData.academicLevel
    }
  },

  computed: {
    ...mapState('AcademicLevel', ['academics']),
  },

  methods: {
    ...mapActions('AcademicLevel', ['fetchAcademics']),
    // handleStatusChange() {
    //   this.activeStatus = this.isActiveStatus ? 'working' : 'pause'
    // },

    async fetchAcademicLevels() {
      await this.fetchAcademics({ status: 'active' })
      this.academicLevelOptions = this.academics || []
    },

    previewImage(file) {
      return typeof file === 'string' ? file : URL.createObjectURL(file)
    },

    triggerImageUpload() {
      this.$refs.uniformFileInput.click()
    },

    handleUniformImageChange(event) {
      const files = Array.from(event.target.files || [])

      this.uniformImages.push(...files)
    },

    removeUniformImage(index) {
      const removedImage = this.uniformImages[index]

      if (typeof removedImage === 'string') {
        this.rawImageRemoved = true
      }

      this.uniformImages.splice(index, 1)
    },

    addOption() {
      this.options.push({ type: '', values: [''] })
    },

    removeOption(index) {
      this.options.splice(index, 1)

      this.generateCombinations()
    },

    addItem(oIndex) {
      this.options[oIndex].values.push('')
    },

    removeItem(oIndex, iIndex) {
      this.options[oIndex].values.splice(iIndex, 1)

      this.generateCombinations()
    },

    formatCurrency(val) {
      return val ? Number(val).toLocaleString('vi-VN') : ''
    },

    hasOption(i) {
      return this.options[i] && this.options[i].values.length
    },

    generateCombinations() {
      // Lấy hai option hiện tại

      const [opt1, opt2] = this.options

      // Nếu không có option nào hoặc giá trị option rỗng => không làm gì cả

      if ((!opt1 || !opt1.values.length) && (!opt2 || !opt2.values.length)) {
        this.combinations = []

        return
      }

      // Tạo mảng combinations mới

      const newCombinations = []

      // Lập ra key-value để dễ dàng tìm kiếm khi cập nhật

      const combinationMap = this.combinations.reduce((acc, comb) => {
        const key = `${comb.optionOne ? comb.optionOne.name : ''}-${comb.optionTwo ? comb.optionTwo.name : ''}`

        acc[key] = comb

        return acc
      }, {})

      // Nếu có 2 options (opt1 và opt2 đều có giá trị)

      if (opt1 && opt1.values.length && opt2 && opt2.values.length) {
        opt1.values.forEach(v1 => {
          if (v1 !== '') {
            opt2.values.forEach(v2 => {
              if (v2 !== '') {
                const key = `${v1}-${v2}`

                if (combinationMap[key]) {
                  // Nếu tồn tại, giữ nguyên giá trị cũ

                  newCombinations.push(combinationMap[key])
                } else {
                  // Nếu không tồn tại, tạo mới

                  newCombinations.push({
                    optionOne: { type: opt1.type, name: v1 },

                    optionTwo: { type: opt2.type, name: v2 },

                    price: '',

                    isActive: true,
                  })
                }
              }
            })
          }
        })
      } else if (opt1 && opt1.values.length) {
        opt1.values.forEach(v1 => {
          if (v1 !== '') {
            const key = `${v1}-`

            if (combinationMap[key]) {
              newCombinations.push(combinationMap[key])
            } else {
              newCombinations.push({
                optionOne: { type: opt1.type, name: v1 },

                optionTwo: null,

                price: '',

                isActive: true,
              })
            }
          }
        })
      }

      // Cập nhật danh sách combinations

      this.combinations = newCombinations
    },

    getData() {
      return {
        id: this.uniformData ? this.uniformData._id : null,
        name: this.name,
        note: this.note,
        academicLevel: this.academicLevel,
        activeStatus: this.activeStatus,
        uniformCombinations: this.combinations,
        images: this.uniformImages,
        rawImageRemoved: this.rawImageRemoved,
      }
    },

    validate() {
      return this.$refs.form.validate()
    },

    resetValidation() {
      this.$refs.form.resetValidation()
    },

    resetDefault() {
      this.name = ''
      this.note = ''
      this.activeStatus = 'working'
      this.academicLevel = ''
      this.academicLevelOptions = this.academics
      // this.isActiveStatus = true
      this.options = [
        {
          type: '',
          values: [''],
        },
      ]
      this.combinations = []
      this.uniformImages = []
      this.rawImageRemoved = false
    },

    extractOptions(combinations) {
      const types = {}
      combinations.forEach(comb => {
        if (comb.optionOne) {
          const { type, name } = comb.optionOne
          if (!types[type]) types[type] = new Set()
          types[type].add(name)
        }
        if (comb.optionTwo) {
          const { type, name } = comb.optionTwo
          if (!types[type]) types[type] = new Set()
          types[type].add(name)
        }
      })
      return Object.keys(types).map(type => ({
        type,
        values: Array.from(types[type]),
      }))
    },
  },

  watch: {
    options: {
      handler() {
        this.generateCombinations()
      },

      deep: true,
    },

    uniformData: {
      immediate: true,

      handler(val) {
        if (val && val.name) {
          this.name = val.name
          this.note = val.note
          this.activeStatus = val.activeStatus
          // this.isActiveStatus = val.activeStatus === 'working'
          this.academicLevel = typeof val.academicLevel === 'object' ? val.academicLevel._id : val.academicLevel || ''
          this.options = this.extractOptions(val.uniformCombinations || [])
          this.combinations = (val.uniformCombinations || []).map(comb => ({
            ...comb,
            price: comb.price ? comb.price : '',
            isActive: comb.isActive !== undefined ? comb.isActive : true,
          }))
          this.uniformImages = (val.images || []).map(img =>
            typeof img === 'string' || img instanceof File ? img : img.url
          )
        }
      },
    },
  },
}
</script>

<style scoped>
.right-input >>> input {
  text-align: right;
  padding-right: 50px;
  width: 60px;
}
.item-category {
  text-align: center;
  padding-top: 18px;
}

.image-preview-wrapper {
  position: relative;
  width: 80px;
  height: 80px;
}

.image-preview {
  width: 100%;
  height: 100%;
  border-radius: 6px;
  background-size: cover;
  background-position: center;
  border: 1px solid #ccc;
  position: relative;
}

.remove-image-btn {
  position: absolute;
  top: -10px;
  right: -10px;
  background: white;
  z-index: 10;
}

.image-upload-add {
  width: 80px;
  height: 80px;
  border: 2px dashed #ccc;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.form-height {
  height: 500px !important;
  max-height: 500px;
  overflow: auto;
  padding-bottom: 4rem;
}

.price-input {
  flex: 1;
}

.price-unit {
  display: flex;
  align-items: center;
  margin-left: 8px;
  position: absolute;
  right: 25px;
  top: 36px;
  transform: translateY(-50%);
  color: #6e6e6e;
  font-size: 14px;
  pointer-events: none;
}

.divider {
  width: 1px;
  height: 39px;
  background-color: #ccc;
  margin-right: 10px;
}

.price-input-wrapper {
  position: relative;
  display: inline-block;
  width: 100%;
  height: 100% !important;
}
</style>
